/** @jsx h */
import { h } from 'preact'
import * as analytics from '../../../../utils/analytics'

const track = (name, analyticsContext) => {
  analytics.track('click_story', {
    eventAction: name,
    eventLabel: analyticsContext
  }, { adapter: 'gtm' })

  analytics.track('story_clicked', {
    object: 'story',
    action: 'clicked',
    subject_name: name,
    event_label: analyticsContext
  }, { adapter: 'segment' })
}

const StoryButton = ({ backgroundImageUrl, onClick, text, name, analyticsContext, fullWidthImage }) => {
  const buttonClicked = e => {
    onClick(e)
    track(name, analyticsContext)
  }

  return (
    <button class={`StoryButton Embed-inner StoryButton--${fullWidthImage ? 'fullWidth' : 'partialWidth'}`} onClick={buttonClicked}>
      <div class='StoryButton-layout' style={{ backgroundImage: `url(${backgroundImageUrl})` }} />
      <div class='StoryButton-mask'>
        <h2 class='Embed-title Text-bodySerif'>{text}</h2>
        <p class='Action--arrow Action--arrowWhite JourneyCard-action'>Explore the story</p>
      </div>
    </button>
  )
}

const StoryButtonList = ({ journeys, onStoryClick, name, analyticsContext, fullWidthImage }) => {
  if (!onStoryClick) return null

  return journeys.map((journey, idx) => {
    const bgImageUrl = journey.stages[0]?.featuredImageUrl || journey.featuredImageUrl
    return (
      <StoryButton
        onClick={onStoryClick(idx)} text={journey.title} backgroundImageUrl={bgImageUrl} name={name} analyticsContext={analyticsContext}
        key={`StoryBtn${idx}`}
        fullWidthImage={fullWidthImage}
      />
    )
  })
}

export default StoryButtonList
